import _taggedTemplateLiteral from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { Typography } from '../../../style/styled';
import t from './theme';
var SmallParagraph = styled(Typography)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-family: var(--primary-font-family);\n    font-stretch: normal;\n    font-style: normal;\n    letter-spacing: normal;\n\n    font-size: 14px;\n    font-weight: normal;\n    line-height: 1.31;\n    color: ", ";\n"])), t.getSmallParagraphTextColor);
export default {
  SmallParagraph: SmallParagraph
};